import { TEMPLATE_TYPES } from 'cpool-constants';
import { divisionId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_DivisionHeaderCreated extends _Event {
    constructor(payload: EventSchema<Template_DivisionHeaderCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        // empty content allowed: blank fields fall back to the standard header/footer
        return z.object({
            divisionId,
            mailContent: z.string(),
            mailHTMLContent: z.string(),
            type: z.literal(TEMPLATE_TYPES.DIVISION_HEADER),
        });
    }

    static example(): EventSchema<Template_DivisionHeaderCreated> {
        return {
            divisionId: 'A1B2C3',
            mailContent: '',
            mailHTMLContent: '',
            type: TEMPLATE_TYPES.DIVISION_HEADER,
        };
    }
}

export type Schema_Template_DivisionHeaderCreated = EventSchema<Template_DivisionHeaderCreated>;
